import { createAsyncThunk } from '@reduxjs/toolkit';
import { _appointmentUrls } from '@custom/Utils/constants/apiUrls';

const appointmentDetails = createAsyncThunk('appointmentDetail', async ({ id }: { id: string }) => {
    try {
      const hospitalId = sessionStorage.getItem('hospitalId') || localStorage.getItem('hospitalId');
      const token = sessionStorage.getItem('token') || localStorage.getItem('token');

      if (!hospitalId) {
        throw new Error('Hospital ID not found in session storage');
      }

      let url = `${_appointmentUrls.detail}`;
      let response = await fetch(url, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          hospitalId: hospitalId,
          id: id,
        }),
      });

      if (!response.ok) {
        throw new Error('Failed to fetch appointment details');
      }

      return await response.json();
    } catch (error) {
      return Promise.reject(error);
    }
  });



export default appointmentDetails;
